<template>
  <div class="inherited-hint" v-if="isOverridden">
    <v-icon size="14" color="primary">mdi-pencil-circle</v-icon>
    <span>Overriding the default {{ fieldLabel }} from Project Settings.</span>
    <button
      type="button"
      class="inherited-hint__action"
      @click="$emit('reset')"
    >
      Reset to default
    </button>
  </div>
  <div class="inherited-hint" v-else-if="defaultValue">
    <v-icon size="14" color="#929292">mdi-link-variant</v-icon>
    <span
      >Currently using the default {{ fieldLabel }} from
      <router-link :to="`/projects/${currentUser.active_project.id}/edit`"
        >Project Settings</router-link
      >: &ldquo;{{ truncatedDefault }}&rdquo;</span
    >
  </div>
  <div class="inherited-hint inherited-hint--warning" v-else>
    <v-icon size="14" color="#c00">mdi-alert-circle-outline</v-icon>
    <span
      >No default {{ fieldLabel }} is set in
      <router-link :to="`/projects/${currentUser.active_project.id}/edit`"
        >Project Settings</router-link
      >, so this will be blank unless one is set here.</span
    >
  </div>
</template>

<script>
export default {
  name: "InheritedTextHint",
  props: {
    value: { type: String, default: "" },
    defaultValue: { type: String, default: "" },
    fieldLabel: { type: String, required: true },
    maxDefaultLength: { type: Number, default: 60 },
  },
  computed: {
    isOverridden() {
      return !!(this.value && this.value.trim());
    },
    truncatedDefault() {
      const value = this.defaultValue || "";
      if (value.length <= this.maxDefaultLength) return value;
      return `${value.slice(0, this.maxDefaultLength)}…`;
    },
  },
};
</script>

<style scoped lang="scss">
.inherited-hint {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.4;
  color: #757575;

  .v-icon {
    margin-top: 1px;
  }

  &__action {
    flex-shrink: 0;
    color: var(--v-primary-base);
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    font-size: inherit;
  }

  &--warning {
    color: #c00;
  }

  ::v-deep a {
    color: inherit;
    text-decoration: underline;
  }
}
</style>
